// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-error {\r\n  text-align: left;\r\n  font: Lato, Regular;\r\n  letter-spacing: 0;\r\n  color: #ff5b5c;\r\n  margin-bottom: 0;\r\n  font-weight: 400;\n}\r\n", ""]);
// Exports
module.exports = exports;
